import BaseDataManager from '../base';
import { CampaignTaskStatus } from './types';

class SearchListTaskManager extends BaseDataManager {
    constructor() {
        super();
    }

    /**
     * Find the latest in progress search task
     * @param orgMemberId The org member we want to find the task for
     * @param campaignId Optional filter to filter by campaign
     */
    public getSearchTaskStatus = async (orgMemberId: string): Promise<CampaignTaskStatus> => {
        const url = this.combineRoute(
            this.BACKEND_ROUTES.TASK.LinkedIn,
            'member',
            orgMemberId,
            'search-list-run-status'
        );
        const response = await this.preventConcurrency(url, () =>
            this.RequestManager.get<CampaignTaskStatus>(url, {}).then((res) => res.data)
        );
        return response;
    };
}

const instance = new SearchListTaskManager();
export { instance as SearchListTaskManager };
